module.exports = __webpack_public_path__ + "static/media/dragon.11e600e1.svg";